// Migrated from app/assets/javascripts/orders/customer_information_step.js
// Dependencies: jQuery, intl-tel-input

import jQuery from 'jquery'
import 'intl-tel-input'

jQuery(function() {

  $("#order_customer_attributes_email_confirm").on("paste", function(e){
    e.preventDefault()
  })

  if ( $("#order_customer_attributes_phone").length === 1 ) {

    $("#order_customer_attributes_phone").intlTelInput({
      preferredCountries:['nl', 'be', 'de', 'fr', 'uk', 'us'],
      initialCountry: 'auto',
      geoIpLookup: function(callback) {
        $.get("https://ipinfo.io", function() {}, "jsonp").always(function(resp) {
          var countryCode = (resp && resp.country) ? resp.country : ""
          callback(countryCode)
        })
      }
    })

    // reset default onclick handler
    $('button#next')[0].onclick = null
    $('button#next').click( function() {
      $("#order_customer_attributes_phone").val( $("#order_customer_attributes_phone").intlTelInput("getNumber") )
      submitform($('button#next')[0])
    })

  }

})
